export default ({ request }) => ({
  techGoodsFabricListApi(data = {}) {
    return request({
      url: '/factory/tech/goods/fabric/list',
      method: 'post',
      data,
    })
  },
  techGoodsFabricDetailApi(data = {}) {
    return request({
      url: '/factory/tech/goods/fabric/detail',
      method: 'post',
      data,
    })
  },
  techGoodsFabricDelApi(data = {}) {
    return request({
      url: '/factory/tech/goods/fabric/del',
      method: 'post',
      data,
    })
  },
  techGoodsFabricAddSaveApi(data = {}) {
    return request({
      url: '/factory/tech/goods/fabric/add/save',
      method: 'post',
      data,
    })
  },
  techGoodsFabricEditSaveApi(data = {}) {
    return request({
      url: '/factory/tech/goods/fabric/edit/save',
      method: 'post',
      data,
    })
  },
})
